export default function(x) {
  return x === null ? NaN : +x;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-array/src/number.js
// module id = 6
// module chunks = 0